import { render } from "./TurnoverStaffCard.vue?vue&type=template&id=396e9c00"
import script from "./TurnoverStaffCard.vue?vue&type=script&lang=js"
export * from "./TurnoverStaffCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__